import React from "react";

export default class FakeCard extends React.Component {
    render() {
        const {cardStyle, className} = this.props;
        return (
            <div style={cardStyle} className={className + ' fake-card'}/>
        )
    }
}